import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var ErrorFilledIcon = function ErrorFilledIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "ErrorFilledIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5.71 1a1.4 1.4 0 0 0-.575.117c-.186.083-.33.198-.444.312L1.429 4.691c-.114.114-.23.258-.312.444A1.4 1.4 0 0 0 1 5.71v4.58c0 .192.033.386.117.575.083.187.198.33.312.444l3.262 3.262c.114.114.258.23.444.312.189.084.383.117.575.117h4.58c.192 0 .386-.033.575-.117.187-.083.33-.198.444-.312l3.262-3.262c.114-.114.23-.257.312-.444.084-.189.117-.383.117-.575V5.71c0-.192-.033-.386-.117-.575a1.5 1.5 0 0 0-.312-.444l-3.262-3.262a1.5 1.5 0 0 0-.444-.312A1.4 1.4 0 0 0 10.29 1zM8.8 5a.8.8 0 0 0-1.6 0v3a.8.8 0 0 0 1.6 0zM8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
      clipRule: "evenodd"
    })
  }));
};

export { ErrorFilledIcon };
